export const deleteDenunceMessage = '  A sua denuncia foi deletada pela administração do Aplicativo de Segurança da mulher.'
+'\n  Para mais informações, entre em contato com a administração';

export const sucessDeletedDenunceMessage = 'A denuncia foi deletada com sucesso. \nNotificações foram enviadas ao usuario';

export const failureDeletedDenunceMessage = 'Erro ao deletar esta denuncia. \nCaso persista, contate o administrador do sistema';



export const deleteDescriptionMessage = 'O seu comentário em uma denuncia foi deletado pela administração do Aplicativo de Segurança da Mulher.'
+ '\n  Para mais informações, entre em contato com a administração';

export const sucessDeletedDescriptionMessage = 'O comentário foi deletado com sucesso. \nNotificações foram enviadas ao usuario';

export const failureDeletedDescriptionMessage = 'Erro ao deletar este comentário. \nCaso persista, contate o administrador do sistema';



export const aproveDescriptionMessage = 'O seu comentário em uma denuncia foi aprovado pela administração do Aplicativo de Segurança da Mulher '
+ 'e agora poderá ser visualizado por todos os usuários.';

export const sucessAprovedDescriptionMessage = 'O comentário foi aprovado com sucesso. \nNotificações foram enviadas ao usuario';

export const failureAprovedDescriptionMessage = 'Erro ao aprovadar este comentário. \nCaso persista, contate o administrador do sistema';